import { type ReactElement } from "react";

export const getIcons = (code: string): ReactElement => {
  switch (code) {
    case "ecs":
      return <icon data-icon-size="48">water_drop</icon>;
    case "chauffage-ecs":
      return (
        <>
          <icon data-icon-size="24">water_drop</icon>
          <icon data-icon-size="24">heat</icon>
        </>
      );
    default:
      return <icon data-icon-size="48">heat</icon>;
  }
};

export function onScrollGlobal() {

  const elem = document.getElementsByClassName("ant-select-dropdown") as HTMLCollection;
  if (elem) {
    Array.from(elem).forEach((e: any) => {
      e.classList?.add("ant-select-dropdown-hidden")
    });
  }

}

export function getRecommendedItem(data: any[] | null, isErrorTxcouv: any): any | null {
  const yesItems = data?.filter(item => item.product.heatpump_recommended === true && !isErrorTxcouv(item));
  // CASE 0: none are "Yes"
  if (!yesItems || yesItems.length === 0) {
    return null;
  }

  // CASE 1: only one is "Yes"
  if (yesItems.length === 1) {
    return yesItems[0];
  }

  // CASE 2+: apply prioritization

  // Step 1: find the min prioritization value
  const minPrio = Math.min(...yesItems.map(i => i.product.heatpump_prio));

  // Step 2: keep only items that share the minimum priority
  const prioItems = yesItems.filter(i => +i.product.heatpump_prio === minPrio);

  if (prioItems.length === 1) {
    return prioItems[0];
  }

  // Step 3: choose the one closest to 70% BUT strictly greater
  const above70 = prioItems.filter(i => i.TxCouvThermo > 70);

  if (above70.length === 0) {
    return prioItems[0];
  }

  // closest to 70% means minimize (value - 70)
  let best = above70[0];
  let diff = above70[0].TxCouvThermo - 70;

  for (let item of above70) {
    const d = item.TxCouvThermo - 70;
    if (d < diff) {
      diff = d;
      best = item;
    }
  }

  return best;
}

